import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useDispatch, useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../hooks/common";
import { action_fetch_message, action_fetch_order_detail, action_fetch_order_review } from "../../../../../../store/actions/pages/customer";
import MeSkeleton from '../../../components/skeleton/index';
import { useSelector } from "react-redux";
import { useState } from "react";
import { disposeComments } from "../../../utils";
import OrderReviewHeader from './review-header/index';
import OrderReviewList from "./review-list";
import { useCallback } from "react";
import { fetchOrderReviewPointsRule } from "../../../../../../api";
import { fetchUnifiedProcessing } from "../../../utils";
import OrderReviewSizeInfomation from './size-infomation/index';
import OrderReviewSubmit from './review-submit/index';
import MeLoading from "../../../components/loading";
import ReviewSuccessPopup from "./review-success";
import { setOrderDetail, setOrderReview } from "../../../../../../store/actions/pages/customer";


const OrderReview = props => {
    useStyles(cls);
    const store = useStore();
    const params = useParams();
    const query = useQuery();
    const pageCustomer = useSelector(state => state.pageCustomer);
    const { orderDetail, orderReview, message } = pageCustomer;
    const [commentsList, setCommentsList] = useState(null);
    const [commentRules, setCommentRules] = useState(null);
    const [sizeInfomation, setSizeInfomation] = useState({
        bust: '',
        height: '',
        hips: '',
        waist: '',
        weight: ''
    });
    const [loading, setLoading] = useState(false);
    const [sizeChange, setSizeChange] = useState(false);
    const [templateStr, setTemplateStr] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const dispatch = useDispatch();

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            await OrderReview.fetchData(store, params, query)
        }

        if (window.GeekoSensors) {
            window.GeekoSensors.Track('EventEnter', {
                page: 'review', //进入留评页
                orderId: params?.orderId
            })
        }
    }, []);

    useEffect(async () => {
        if (orderReview && orderDetail) {
            let comments = disposeComments(orderReview?.comments, orderDetail?.orderItems);
            setCommentsList(comments);

            let initMySizeInformation = {
                height: "",
                weight: "",
                bust: "",
                hips: "",
                waist: ""
            };

            if (orderReview?.mySizeInformation) {
                setSizeInfomation({ ...initMySizeInformation, ...orderReview.mySizeInformation });
            } else {
                setSizeInfomation(initMySizeInformation);
            }
        }
    }, [orderDetail, orderReview]);

    useEffect(async () => {
        let response = await fetchOrderReviewPointsRule();
        setCommentRules(fetchUnifiedProcessing(response));
    }, []);

    useEffect(() => {
        return () => {
            dispatch(setOrderDetail(null));
            dispatch(setOrderReview(null));
        }
    }, []);

    const updateComments = useCallback((comment) => {
        // let newComments = listRef.current?.map((item, index)=>item?.id===comment?.id ? ({...item, ...comment}) : item);
        setCommentsList(state => (state?.map((item, index) => ((!!comment?.id) && item?.id === comment?.id) || item?.variantId === comment?.variantId ? ({ ...item, ...comment }) : item)));
    }, [commentsList]);

    return <div className={cls.OrderReview}>
        {
            orderDetail && orderReview && commentsList ? <React.Fragment>
                <OrderReviewHeader
                    orderReview={orderReview}
                    orderDetail={orderDetail}
                    commentsList={commentsList}
                    commentRules={commentRules}
                    sizeInfomation={sizeInfomation}
                />

                <OrderReviewList
                    commentsList={commentsList}
                    updateComments={(comment) => updateComments(comment)}
                    commentRules={commentRules}
                    orderReview={orderReview}
                    setLoading={setLoading}
                />

                <OrderReviewSizeInfomation
                    sizeInfomation={sizeInfomation}
                    commentRules={commentRules}
                    setSizeInfomation={setSizeInfomation}
                    setSizeChange={setSizeChange}
                    message={message['M1813']}
                />

                <OrderReviewSubmit
                    sizeInfomation={sizeInfomation}
                    commentsList={commentsList}
                    orderDetail={orderDetail}
                    sizeChange={sizeChange}
                    setTemplateStr={(str) => {
                        setShowPopup(true);
                        setTemplateStr(str);
                    }}
                />

                <MeLoading loading={loading} />

                <ReviewSuccessPopup
                    show={showPopup}
                    orderId={orderDetail?.id}
                    onClose={() => setShowPopup(false)}
                    templateStr={templateStr}
                />
            </React.Fragment> : <MeSkeleton />
        }
    </div>
}


OrderReview.fetchData = async (store, params, search, headers) => {
    const fetchOrderDetail = store.dispatch(action_fetch_order_detail(params.orderId, headers));
    const fetchOrderView =  store.dispatch(action_fetch_order_review(params.orderId, headers));
    const fetchMessage = await store.dispatch(action_fetch_message('M1813'));

    const result = await Promise.all([fetchOrderDetail, fetchOrderView, fetchMessage])
    return result
}

export default OrderReview;